import { Buffer } from 'buffer';
import { TestDataBuffer } from "@/types";
import { resolveApiUrl } from "./apiUrl";
declare const __APP_CONFIG__: { apiUrl: string; version: string; builtAt: string };

export const testDataOnStart: TestDataBuffer = {
    global: [],
    voice: {
      textMatrix: [],
      timestamps: [],
      activitiTimestamps: [],
      audio: Buffer.alloc(1)
    },
    writing: {
      behaviour: [],
      image: Buffer.alloc(1)
    },
    printing: {
      behaviour: []
    }
  };
  
// Для независимых поддоменов задайте API_URL в frontend/.env перед сборкой.
// Без него сохраняется схема api.<домен фронтенда>.
export const serverUrl = resolveApiUrl(
  typeof window === "undefined" ? undefined : window.location,
  __APP_CONFIG__.apiUrl
);

// Текущая версия приложения. Обновляйте с каждой итерацией.
export const APP_VERSION = __APP_CONFIG__.version;
export const APP_BUILD_TIME = __APP_CONFIG__.builtAt;

// Резервное число требуемых попыток, если сервер не вернул значение.
export const REQUIRED_ATTEMPTS_FALLBACK = 5;
